/* VCTparts: favorieten en "Bewaar voor later", zonder account en zonder app.
   Alles staat in localStorage van deze browser:
   - 'vct-fav-v1':   [{ h: handle, t: tijdstip }], nieuwste eerst, max. 50.
   - 'vct-later-v1': [{ v, h, q, p, n, vt, i, pr, u, t }] = variant, handle,
     aantal, eigenschappen (ook die met '_', die tonen we alleen niet), naam,
     variantnaam, foto, stukprijs in centen, url, tijdstip. Max. 30.
   Onderdelen:
   - Hartje [data-vct-fav="handle"] op productkaarten en de productpagina
     (aria-pressed), plus het hartje in de header [data-vct-fav-head] dat
     alleen verschijnt met minstens één favoriet.
   - Favorietenpagina [data-vct-favs] (sections/vct-favorieten.liquid): haalt
     per product de gewone kaart op via ?section_id=product-item.
   - Winkelwagen (lade en pagina): [data-vct-later-save="line key"] zet een
     regel opzij (/cart/change.js aantal 0), de lijst [data-vct-later] toont
     de bewaarde regels en zet ze terug via /cart/add.js. Xtra vervangt de
     lade-HTML na elke wijziging; een MutationObserver tekent de lijst dan
     opnieuw (zoals assets/vct-cart.js).
   Synchronisatie tussen apparaten (ingelogde klanten) kan niet zonder app:
   dat vraagt customer metafields via een app of app-proxy. */
(function () {
  'use strict';

  var FAV_KEY = 'vct-fav-v1';
  var LATER_KEY = 'vct-later-v1';
  var FAV_MAX = 50;
  var LATER_MAX = 30;
  var LATER_SHOW = 3;
  var LANG = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var T = {
    nl: {
      add: 'Bewaar als favoriet', remove: 'Favoriet verwijderen',
      later: 'Bewaard voor later', back: 'Terug in winkelwagen', del: 'Verwijder',
      all: 'Toon alles', less: 'Toon minder', gone: 'Niet meer beschikbaar', err: 'Dat lukte niet, probeer het opnieuw.'
    },
    de: {
      add: 'Als Favorit merken', remove: 'Favorit entfernen',
      later: 'Für später gemerkt', back: 'Zurück in den Warenkorb', del: 'Entfernen',
      all: 'Alle anzeigen', less: 'Weniger anzeigen', gone: 'Nicht mehr verfügbar', err: 'Das hat nicht geklappt, bitte versuche es erneut.'
    },
    fr: {
      add: 'Ajouter aux favoris', remove: 'Retirer des favoris',
      later: 'Gardé pour plus tard', back: 'Remettre dans le panier', del: 'Supprimer',
      all: 'Tout afficher', less: 'Afficher moins', gone: 'Plus disponible', err: 'Cela n’a pas fonctionné, veuillez réessayer.'
    },
    en: {
      add: 'Save as favourite', remove: 'Remove favourite',
      later: 'Saved for later', back: 'Move to cart', del: 'Remove',
      all: 'Show all', less: 'Show less', gone: 'No longer available', err: 'That did not work, please try again.'
    }
  };
  var t = T[LANG] || T.nl;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---- Opslag ----------------------------------------------------------- */

  function read(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }

  function write(key, list) {
    try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) { /* vol of geblokkeerd: dan alleen deze pagina */ }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Bedrag in de winkelnotatie (zonder euroteken, zoals de rest van de
     winkel). Xtra's eigen Shopify.formatMoney als die er is. */
  function money(cents) {
    var format = (window.general && window.general.currency) || '{{amount_with_comma_separator}}';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch (e) { /* dan zelf */ }
    }
    var n = (Math.round(cents) / 100).toFixed(2).split('.');
    var comma = format.indexOf('comma') > -1;
    var whole = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
    return format.replace(/\{\{\s*\w+\s*\}\}/, whole + (comma ? ',' : '.') + n[1]);
  }

  /* ---- Favorieten ------------------------------------------------------- */

  function favs() { return read(FAV_KEY); }

  function isFav(handle) {
    return favs().some(function (f) { return f.h === handle; });
  }

  function toggleFav(handle) {
    var list = favs();
    var had = list.some(function (f) { return f.h === handle; });
    list = list.filter(function (f) { return f.h !== handle; });
    if (!had) list.unshift({ h: handle, t: Date.now() });
    write(FAV_KEY, list.slice(0, FAV_MAX));
    return !had;
  }

  function syncFavs() {
    var list = favs();
    var set = {};
    list.forEach(function (f) { set[f.h] = true; });
    var btns = document.querySelectorAll('[data-vct-fav]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var on = !!set[b.getAttribute('data-vct-fav')];
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      if (b.hasAttribute('data-vct-fav-name')) {
        var label = (on ? t.remove : t.add);
        b.setAttribute('title', label);
        b.setAttribute('aria-label', label + ': ' + b.getAttribute('data-vct-fav-name'));
      }
    }
    var heads = document.querySelectorAll('[data-vct-fav-head]');
    for (var h = 0; h < heads.length; h++) heads[h].hidden = !list.length;
    var counts = document.querySelectorAll('[data-vct-fav-count]');
    for (var c = 0; c < counts.length; c++) counts[c].textContent = list.length ? String(list.length) : '';
  }

  /* ---- Favorietenpagina ------------------------------------------------- */

  var favsLoaded = false;

  function favsEmpty(page) {
    var list = page.querySelector('[data-vct-favs-list]');
    var n = list ? list.children.length : 0;
    var empty = page.querySelector('[data-vct-favs-empty]');
    if (empty) empty.hidden = n > 0;
    var count = page.querySelector('[data-vct-favs-count]');
    if (count) count.textContent = n ? '(' + n + ')' : '';
  }

  /* De echte productkaart (sections/product-item.liquid) per handle; een
     product dat niet meer bestaat (404) of niet laadt valt stil weg. */
  function fetchCard(handle) {
    return fetch(root() + 'products/' + encodeURIComponent(handle) + '?section_id=product-item', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.product-card');
        if (!card || card.classList.contains('placeholder-product')) return null;
        card.setAttribute('data-vct-fav-card', handle);
        return card;
      })
      .catch(function () { return null; });
  }

  function loadFavsPage() {
    var page = document.querySelector('[data-vct-favs]');
    if (!page || favsLoaded) return;
    favsLoaded = true;
    var list = page.querySelector('[data-vct-favs-list]');
    var loading = page.querySelector('[data-vct-favs-loading]');
    var handles = favs().map(function (f) { return f.h; });
    var cards = new Array(handles.length);
    var next = 0;
    var gone = [];

    function worker() {
      if (next >= handles.length) return Promise.resolve();
      var n = next++;
      return fetchCard(handles[n]).then(function (card) {
        if (card) cards[n] = card;
        else gone.push(handles[n]);
        return worker();
      });
    }

    var pool = [];
    for (var w = 0; w < Math.min(4, handles.length); w++) pool.push(worker());
    Promise.all(pool).then(function () {
      cards.forEach(function (card) { if (card) list.appendChild(card); });
      if (gone.length) write(FAV_KEY, favs().filter(function (f) { return gone.indexOf(f.h) < 0; }));
      if (loading) loading.hidden = true;
      // Xtra's kaartfuncties (sterren, snel kopen) opnieuw aanzetten, zoals bij "recent bekeken"
      try { window.dispatchEvent(new CustomEvent('ratings')); } catch (e) {}
      try { window.dispatchEvent(new CustomEvent('semanticInput')); } catch (e) {}
      try { if (window.ajaxCart && window.ajaxCart.init) window.ajaxCart.init(); } catch (e) {}
      try { if (window.quickShop && window.quickShop.init) window.quickShop.init(); } catch (e) {}
      syncFavs();
      favsEmpty(page);
    });
  }

  /* Hartje uit op de favorietenpagina: de kaart rustig weghalen */
  function dropFavCard(handle) {
    var card = document.querySelector('[data-vct-favs] [data-vct-fav-card="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]');
    if (!card) return;
    card.classList.add('is-leaving');
    setTimeout(function () {
      if (card.parentNode) card.parentNode.removeChild(card);
      favsEmpty(document.querySelector('[data-vct-favs]'));
    }, 200);
  }

  /* ---- Bewaar voor later ------------------------------------------------ */

  var laterOpen = false;
  var busy = false;

  function laterKey(item) {
    return item.v + '|' + JSON.stringify(item.p || {});
  }

  function inDrawer(el) { return !!(el && el.closest && el.closest('#cart')); }

  function json(url, body) {
    return fetch(root() + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok || data.status) {
          var err = new Error(data.description || data.message || r.status);
          err.status = r.status;
          throw err;
        }
        return data;
      });
    });
  }

  /* Na een wijziging verversen zoals Xtra en vct-cart.js het doen: de lade
     krijgt de nieuwe sectie-HTML (zelfde pad als na verwijderen), op de
     winkelwagenpagina laadt de pagina opnieuw zodat regels en totalen kloppen. */
  function refresh(data) {
    var page = document.querySelector('form.form-cart, article.cart-empty');
    if (page && !inDrawer(page)) {
      window.location.reload();
      return;
    }
    if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
      try {
        if (data && data.sections && data.sections['side-cart']) window.ajaxCart.load(data, true);
        else window.ajaxCart.load(false, true, false, true);
        return;
      } catch (e) { /* dan alleen de teller */ }
    }
    fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = document.getElementById('cart-count');
        if (count && cart && typeof cart.item_count === 'number') count.textContent = cart.item_count;
      })
      .catch(function () {});
    renderLater();
  }

  function saveForLater(btn) {
    if (busy) return;
    busy = true;
    btn.disabled = true;
    var key = btn.getAttribute('data-vct-later-save');
    var line = btn.closest('li');
    if (line) line.classList.add('processing');
    fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = (cart.items || []).filter(function (i) { return i.key === key; })[0];
        if (!item) throw new Error('line');
        var entry = {
          v: item.variant_id,
          h: item.handle,
          q: item.quantity,
          p: item.properties || {},
          n: item.product_title,
          vt: item.product_has_only_default_variant ? '' : (item.variant_title || ''),
          i: item.image || (item.featured_image && item.featured_image.url) || '',
          pr: item.final_price,
          u: item.url,
          t: Date.now()
        };
        var list = read(LATER_KEY);
        var same = list.filter(function (l) { return laterKey(l) === laterKey(entry); })[0];
        if (same) entry.q += same.q;
        list = list.filter(function (l) { return laterKey(l) !== laterKey(entry); });
        list.unshift(entry);
        write(LATER_KEY, list.slice(0, LATER_MAX));
        return json('cart/change.js', { id: key, quantity: 0, sections: 'side-cart' });
      })
      .then(function (data) { busy = false; refresh(data); })
      .catch(function () {
        busy = false;
        btn.disabled = false;
        if (line) line.classList.remove('processing');
      });
  }

  function moveBack(btn) {
    if (busy) return;
    var k = btn.getAttribute('data-vct-later-back');
    var entry = read(LATER_KEY).filter(function (l) { return laterKey(l) === k; })[0];
    if (!entry) return renderLater();
    busy = true;
    btn.disabled = true;
    json('cart/add.js', { items: [{ id: entry.v, quantity: entry.q, properties: entry.p || {} }], sections: 'side-cart' })
      .then(function (data) {
        busy = false;
        write(LATER_KEY, read(LATER_KEY).filter(function (l) { return laterKey(l) !== k; }));
        refresh(data);
      })
      .catch(function (err) {
        busy = false;
        btn.disabled = false;
        var row = btn.closest('.vct-later__item');
        var note = row && row.querySelector('.vct-later__note');
        if (note) {
          note.textContent = err && (err.status === 422 || err.status === 404) ? t.gone : t.err;
          note.hidden = false;
        }
      });
  }

  function removeLater(btn) {
    var k = btn.getAttribute('data-vct-later-del');
    write(LATER_KEY, read(LATER_KEY).filter(function (l) { return laterKey(l) !== k; }));
    renderLater(true);
  }

  function thumb(src) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  function laterHtml(list) {
    var rows = list.map(function (l, n) {
      var k = esc(laterKey(l));
      var meta = [];
      if (l.vt) meta.push(esc(l.vt));
      Object.keys(l.p || {}).forEach(function (name) {
        var val = l.p[name];
        if (name.charAt(0) === '_' || val === '' || val == null) return; // verborgen eigenschap: wel bewaren, niet tonen
        meta.push(esc(name) + ': ' + esc(val));
      });
      if (l.q > 1) meta.push(l.q + '×');
      var url = esc(l.u || (root() + 'products/' + l.h));
      return '<li class="vct-later__item"' + (n >= LATER_SHOW && !laterOpen ? ' hidden' : '') + '>' +
        '<a class="vct-later__img" href="' + url + '" tabindex="-1" aria-hidden="true">' +
          (l.i ? '<img src="' + esc(thumb(l.i)) + '" alt="" width="56" height="56" loading="lazy">' : '') +
        '</a>' +
        '<div class="vct-later__body">' +
          '<a class="vct-later__name" href="' + url + '">' + esc(l.n) + '</a>' +
          (meta.length ? '<span class="vct-later__meta">' + meta.join(' · ') + '</span>' : '') +
          '<span class="vct-later__price">' + esc(money((l.pr || 0) * (l.q || 1))) + '</span>' +
          '<span class="vct-later__acts">' +
            '<button type="button" class="vct-later__back" data-vct-later-back="' + k + '">' + esc(t.back) + '</button>' +
            '<button type="button" class="vct-later__del" data-vct-later-del="' + k + '">' + esc(t.del) + '</button>' +
          '</span>' +
          '<span class="vct-later__note" role="status" hidden></span>' +
        '</div>' +
      '</li>';
    }).join('');
    var more = list.length > LATER_SHOW
      ? '<button type="button" class="vct-later__more" data-vct-later-more aria-expanded="' + laterOpen + '">' +
          esc(laterOpen ? t.less : t.all + ' (' + list.length + ')') + '</button>'
      : '';
    return '<h3 class="vct-later__title">' + esc(t.later) + ' <span>(' + list.length + ')</span></h3>' +
      '<ul class="vct-later__list">' + rows + '</ul>' + more;
  }

  /* Plek voor de lijst: de [data-vct-later] uit de Liquid, of (oudere HTML)
     direct na de regels. */
  function laterMounts() {
    var mounts = Array.prototype.slice.call(document.querySelectorAll('[data-vct-later]'));
    var spots = [
      document.querySelector('#cart > ul.l4ca'),
      document.querySelector('.form-cart ul.l4ca:not(.l4ca-bundle)'),
      document.querySelector('.cart-empty')
    ];
    spots.forEach(function (spot) {
      if (!spot) return;
      var scope = spot.closest('#cart') || spot.closest('.shopify-section') || spot.parentNode;
      if (scope.querySelector('[data-vct-later]')) return;
      var div = document.createElement('div');
      div.className = 'vct-later';
      div.setAttribute('data-vct-later', '');
      div.hidden = true;
      if (spot.classList.contains('cart-empty')) spot.appendChild(div);
      else spot.parentNode.insertBefore(div, spot.nextSibling);
      mounts.push(div);
    });
    return mounts;
  }

  function renderLater(force) {
    var list = read(LATER_KEY);
    var sig = JSON.stringify(list) + laterOpen;
    laterMounts().forEach(function (m) {
      if (!force && m.getAttribute('data-vct-sig') === sig) return;
      m.setAttribute('data-vct-sig', sig);
      m.innerHTML = list.length ? laterHtml(list) : '';
      m.hidden = !list.length;
    });
  }

  /* ---- Bedrading -------------------------------------------------------- */

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-vct-fav], [data-vct-later-save], [data-vct-later-back], [data-vct-later-del], [data-vct-later-more]');
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    if (el.hasAttribute('data-vct-fav')) {
      var handle = el.getAttribute('data-vct-fav');
      var on = toggleFav(handle);
      syncFavs();
      if (!on) dropFavCard(handle);
    } else if (el.hasAttribute('data-vct-later-save')) {
      saveForLater(el);
    } else if (el.hasAttribute('data-vct-later-back')) {
      moveBack(el);
    } else if (el.hasAttribute('data-vct-later-del')) {
      removeLater(el);
    } else {
      laterOpen = !laterOpen;
      renderLater(true);
      var more = document.querySelector('#cart [data-vct-later-more]') || document.querySelector('[data-vct-later-more]');
      if (more && el.closest('#cart')) more.focus();
    }
  }, true);

  // Andere tab of venster: zelfde stand
  window.addEventListener('storage', function (e) {
    if (e.key === FAV_KEY) syncFavs();
    if (e.key === LATER_KEY) renderLater();
  });

  var timer = null;
  function run() {
    timer = null;
    syncFavs();
    renderLater();
  }
  function schedule() { if (!timer) timer = setTimeout(run, 60); }

  function init() {
    run();
    loadFavsPage();
    if (!('MutationObserver' in window)) return;
    // Nieuwe HTML (lade, winkelwagenpagina, meer producten laden, filters): opnieuw bijwerken
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var nodes = records[i].addedNodes;
        for (var n = 0; n < nodes.length; n++) {
          var node = nodes[n];
          if (node.nodeType !== 1) continue;
          if (node.closest && node.closest('[data-vct-later]')) continue; // eigen lijst
          if (node.matches('[data-vct-fav], [data-vct-later], .l4ca') || node.querySelector('[data-vct-fav], .l4ca, [data-vct-later]')) return schedule();
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
